import { gmapApi } from 'gmap-vue'

export default {
  google() {
    return gmapApi()
  },
  reverseGeocoder(lat, lng, ref) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
      var service = new google.maps.Geocoder(ref)
      let request = {
        location: {
          lat: lat,
          lng: lng
        }
      }
      service.geocode(request, (results, status) => {
        if (status === 'OK') {
          //console.log("Geocoder Results", results);
          if (results[0]) {
            resolve(results[0])
          } else {
            reject({
              code: 'NoResults',
              message: 'Google Geocoder: Sem resultados encontrados.'
            })
          }
        } else {
          reject({
            code: 'status',
            message: 'Google Geocoder falhou por: ' + status
          })
        }
      })
    })
  },
  geocoder(query, ref) {
    //PRICING:
    //0–100,000 -> 0.005 USD per each (5.00 USD per 1000)
    //100,001–500,000 -> 0.004 USD per each (4.00 USD per 1000)
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
      var service = new google.maps.Geocoder(ref)
      let request = {
        address: query,
        region: 'BR'
      }
      service.geocode(request, (results, status) => {
        if (status === 'OK') {
          //console.log("Geocoder Results", results);
          if (results[0]) {
            resolve(results[0])
          } else {
            reject({
              code: 'NoResults',
              message: 'Google Geocoder: Sem resultados encontrados.'
            })
          }
        } else {
          reject({
            code: 'status',
            message: 'Google Geocoder falhou por: ' + status
          })
        }
      })
    })
  },
  findPlaceFromQuery(query, ref) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
      const service = new google.maps.places.PlacesService(ref)
      let request = {
        query: query,
        fields: ['formatted_address', 'name', 'geometry', 'place_id']
      }
      service.findPlaceFromQuery(request, function(results, status) {
        if (status === 'OK') resolve(results)
        else reject('Erro na api do Google')
      })
    })
  },
  getDetails(p, ref) {
    return new Promise((resolve, reject) => {
      var request = {
        placeId: p.place_id,
        fields: ['name', 'address_component', 'formatted_address', 'geometry']
      }
      // eslint-disable-next-line
      const service = new google.maps.places.PlacesService(ref)
      service.getDetails(request, callback)
      function callback(place, status) {
        if (status === 'OK') {
          resolve(place)
        } else reject('Erro na api do google')
      }
    })
  }
  /*
  fetchPlace() {
    // console.log("FecthAddress -> Google initializing...");
    let vm = this;
    vm.fetching = true;
    vm.myMap.$mapPromise.then((map) => {
      var service = new this.google.maps.places.PlacesService(map);
      //map.setZoom(15);
      // console.log("FecthAddress ->Initialized!", service);
      let request = {
        query:
          vm.residence_data.endereco +
          ", " +
          vm.residence_data.numero +
          " - " +
          vm.residence_data.bairro +
          ", " +
          vm.residence_data.cidade,
        fields: ["formatted_address", "name", "geometry", "place_id"],
      };
      //console.log("FecthAddress -> Making Request..." , request);
      service.findPlaceFromQuery(request, function (results, status) {
        //console.log("FecthAddress -> Returned...", status);
        //console.log("Result from fetch", results);
        if (status === vm.google.maps.places.PlacesServiceStatus.OK) {
          vm.places = results;
          vm.parsePlace(service, map);
        } else {
          let request = {
            query: vm.residence_data.bairro + ", " + vm.residence_data.cidade,
            fields: ["formatted_address", "name", "geometry", "place_id"],
          };
          service.findPlaceFromQuery(request, function (results, status) {
            //console.log("FecthAddress Second Attempt -> Returned...", status);
            //console.log("Result from second fetch", results);
            if (status === vm.google.maps.places.PlacesServiceStatus.OK) {
              vm.places = results;
              vm.parsePlace(service, map);
            }
          });
        }
      });
    });
  },
  parsePlace(service, map) {
    let vm = this;
    vm.places.forEach((p) => {
      var request = {
        placeId: p.place_id,
        fields: [
          "name",
          "address_component",
          "formatted_address",
          "geometry",
        ],
      };

      service = new vm.google.maps.places.PlacesService(map);
      service.getDetails(request, callback);

      function callback(place, status) {
        if (status == vm.google.maps.places.PlacesServiceStatus.OK) {
          //console.log("Details: ", place);
          vm.point.position.lat = place.geometry.location.lat();
          vm.point.position.lng = place.geometry.location.lng();
          vm.residence_data.latitude = vm.point.position.lat;
          vm.residence_data.longitude = vm.point.position.lng;
          map.panTo({
            lat: vm.point.position.lat,
            lng: vm.point.position.lng,
          });
          if (vm.tipo == "Cliente") vm.register();
        }
      }
    });
    vm.fetching = false;
    //vm.addLocationsToGoogleMaps(map);
  },*/
}
